import type { DocCategory } from '../registry';
import SystemRequirements, { toc as systemRequirementsToc } from '../pages/reference/system-requirements';
import SupportedFormats, { toc as supportedFormatsToc } from '../pages/reference/supported-formats';
import Models, { toc as modelsToc } from '../pages/reference/models';
import WhereYourDataLives, { toc as whereYourDataLivesToc } from '../pages/reference/where-your-data-lives';
import McpTools, { toc as mcpToolsToc } from '../pages/reference/mcp-tools';

export const reference: DocCategory = {
  id: 'reference',
  label: 'Reference',
  pages: [
    {
      slug: 'reference/system-requirements',
      title: 'System requirements',
      eyebrow: 'Reference',
      description: 'The hard requirements — an NVIDIA CUDA GPU is required.',
      toc: systemRequirementsToc,
      Body: SystemRequirements,
      related: [
        { label: 'AI models & your GPU', to: '/docs/concepts/models-and-your-gpu' },
        { label: 'Download & install', to: '/docs/install' },
        { label: "ClipRadar can't find my GPU", to: '/docs/troubleshooting/gpu-not-detected' },
        { label: 'Supported file formats', to: '/docs/reference/supported-formats' },
      ],
    },
    {
      slug: 'reference/supported-formats',
      title: 'Supported file formats',
      eyebrow: 'Reference',
      description: 'The exact list of video and image formats ClipRadar can analyze.',
      toc: supportedFormatsToc,
      Body: SupportedFormats,
      related: [
        { label: 'Analyzing your footage', to: '/docs/concepts/analyzing-media' },
        { label: 'System requirements', to: '/docs/reference/system-requirements' },
      ],
    },
    {
      slug: 'reference/models',
      title: 'Machine-learning models',
      eyebrow: 'Reference',
      description: "The model roster — what each does, how it's chosen, and where the downloads live.",
      toc: modelsToc,
      Body: Models,
      related: [
        { label: 'AI models & your GPU', to: '/docs/concepts/models-and-your-gpu' },
        { label: 'Where ClipRadar stores things', to: '/docs/reference/where-your-data-lives' },
        { label: 'Ultra Search', to: '/docs/concepts/ultra-search' },
      ],
    },
    {
      slug: 'reference/where-your-data-lives',
      title: 'Where ClipRadar stores things',
      eyebrow: 'Reference',
      description: 'The on-disk map — data root, cache, models, exports, logs, settings, and license.',
      toc: whereYourDataLivesToc,
      Body: WhereYourDataLives,
      related: [
        { label: 'Local & private', to: '/docs/concepts/local-and-private' },
        { label: 'Analyzing your footage', to: '/docs/concepts/analyzing-media' },
        { label: 'Uninstall ClipRadar', to: '/docs/guides/uninstall' },
      ],
    },
    {
      slug: 'reference/mcp-tools',
      title: 'MCP tool reference',
      eyebrow: 'Reference',
      description: 'The full agentic tool surface, grouped by intent — for agent and skill authors.',
      toc: mcpToolsToc,
      Body: McpTools,
      related: [
        { label: 'Agentic editing (MCP)', to: '/docs/concepts/agentic-editing' },
        { label: 'Your first agentic edit', to: '/docs/guides/agentic-editing-quickstart' },
      ],
    },
  ],
};
